import axios from '@/libs/axios'

export default {
  namespaced: true,

  state: {
    companies: [],
    companySettings: null,
    countries: [],
    regionsByCountry: {},
    regionsById: {},
    currencies: [],
    timezones: [],
    companyNames: [],
    companyNamesPictures: [],
    companyNamesPackagesPictures: [],
  },

  getters: {
    companies(state) {
      return state.companies
    },
    companySettings(state) {
      return state.companySettings
    },
    countries(state) {
      return state.countries
    },
    regionsByCountry(state) {
      return state.regionsByCountry
    },
    regionsById(state) {
      return state.regionsById
    },
    currencies(state) {
      return state.currencies
    },
    timezones(state) {
      return state.timezones
    },
    companyNames(state) {
      return state.companyNames
    },
    companyNamesPictures(state) {
      return state.companyNamesPictures
    },
    companyNamesPackagesPictures(state) {
      return state.companyNamesPackagesPictures
    },
  },

  mutations: {
    SET_COMPANIES(state, value) {
      state.companies = value
    },
    SET_COMPANY_SETTINGS(state, value) {
      state.companySettings = value
    },
    SET_COUNTRIES(state, value) {
      state.countries = value
    },
    SET_REGIONS_FOR_COUNTRY(state, { countryId, regions }) {
      const nextById = { ...state.regionsById }
      ;(regions || []).forEach((region) => {
        if (region?.id != null) {
          nextById[String(region.id)] = region
        }
      })

      state.regionsById = nextById
      state.regionsByCountry = {
        ...state.regionsByCountry,
        [String(countryId)]: regions,
      }
    },
    SET_REGION(state, region) {
      if (!region?.id) {
        return
      }
      state.regionsById = {
        ...state.regionsById,
        [String(region.id)]: region,
      }
    },
    SET_CURRENCIES(state, value) {
      state.currencies = value
    },
    SET_TIMEZONES(state, value) {
      state.timezones = value
    },
    SET_COMPANY_NAMES(state, value) {
      state.companyNames = value
    },
    SET_COMPANY_NAMES_PICTURES(state, value) {
      state.companyNamesPictures = value
    },
    SET_COMPANY_NAMES_PACKAGES_PICTURES(state, value) {
      state.companyNamesPackagesPictures = value
    },
    UPDATE_COMPANIES(state, data) {
      const index = state.companies.findIndex(company => company.id == data.id)
      console.log('state.companies[index]', state.companies[index]);
      console.log('data=', data);
      Object.assign(state.companies[index], data);
    },
    ADD_COMPANY(state, data) {
      state.companies.unshift(data);
    }
  },

  actions: {
    loadCompanies({ commit }) {
      return axios.get('api/companies').then(response => {
        commit('SET_COMPANIES', response.data.data)
      })
    },
    loadCompanySettings({ commit }) {
      return axios.get('api/company/settings').then(response => {
        commit('SET_COMPANY_SETTINGS', response.data.data)
        return response.data.data
      })
    },
    loadCountries({ commit }) {
      return axios.get('api/countries').then(response => {
        commit('SET_COUNTRIES', response.data.data)
        return response.data.data
      })
    },
    loadRegions({ commit, state }, countryId) {
      if (!countryId) {
        return Promise.resolve([])
      }

      const key = String(countryId)
      if (Array.isArray(state.regionsByCountry[key])) {
        return Promise.resolve(state.regionsByCountry[key])
      }

      return axios.get('api/regions', { params: { country_id: countryId } }).then((response) => {
        const data = response.data.data ?? response.data ?? []
        commit('SET_REGIONS_FOR_COUNTRY', { countryId: key, regions: data })
        return data
      })
    },
    loadRegion({ commit, state }, regionId) {
      if (regionId == null || regionId === '') {
        return Promise.resolve(null)
      }

      const key = String(regionId)
      if (state.regionsById[key]) {
        return Promise.resolve(state.regionsById[key])
      }

      return axios.get(`api/regions/${regionId}`).then((response) => {
        const data = response.data.data ?? response.data ?? null
        if (data) {
          commit('SET_REGION', data)
        }
        return data
      })
    },
    loadCurrencies({ commit }) {
      return axios.get('api/currencies').then(response => {
        const data = response.data.data ?? response.data
        commit('SET_CURRENCIES', data)
        return data
      })
    },
    loadTimezones({ commit }) {
      return axios.get('api/timezones').then(response => {
        const data = response.data.data ?? response.data
        commit('SET_TIMEZONES', data)
        return data
      })
    },
    loadCompanyNames({ commit }) {
      return axios.get('api/company-names').then(response => {
        commit('SET_COMPANY_NAMES', response.data)
      })
    },
    loadCompanyNamesPictures({ commit }) {
      return axios.get('api/company-names-pictures').then(response => {
        commit('SET_COMPANY_NAMES_PICTURES', response.data.data)
      })
    },
    loadCompanyNamesPackagesPictures({ commit }) {
      return axios.get('api/company-names-packages-pictures').then(response => {
        commit('SET_COMPANY_NAMES_PACKAGES_PICTURES', response.data.data)
      })
    },
    updateCompany({ commit }, { formData }) {
      return axios.post(`api/companies/${formData.get('id')}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        console.log('response.data.data', response.data.data);
        commit('UPDATE_COMPANIES', response.data.data)
      })
    },
    addCompany({ commit }, { formData }) {
      return axios.post(`api/companies`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        commit('ADD_COMPANY',  response.data.data);
        return response;
      })
    },
    registerCompany({ commit }, { formData }) {
      return axios.post(`api/register-company`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        commit('ADD_COMPANY',  response.data.data);
        return response;
      })
    },
    updateCompanySettings({ commit }, { formData }) {
      return axios.post('api/company/settings', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        commit('SET_COMPANY_SETTINGS', response.data.data)
        return response.data.data
      })
    }
  },
}
